<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="500px">
    <template v-slot:activator="{ on }" v-if="!disableFields">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="!hideOpenButton"

            v-on="on"

            dark
            small
            fab

            color="light-blue darken-4"
            @click="openForm()"
          >
            <v-icon>unarchive</v-icon>
          </v-btn>
        </template>
        <span>Enviar Arquivo</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">Enviar arquivo</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <v-form ref="uploadForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12>
                <v-flex xs12>
                  <div style="position:relative;">
                    <v-text-field
                      ref="iptFile"
                      label="Selecione um arquivo"
                      @click="pickFile"
                      v-model="formData.fileName"
                      append-icon="attach_file"
                    ></v-text-field>
                    <input
                      class="fileToSend"
                      type="file"
                      style="display: none"
                      ref="selectedFile"
                      @change="onFilePicked"
                    />
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                sm5
                optionalFields
                pr-3
                v-show="uploadType != 'attchment' && !financialUploadMode"
              >
                <v-menu
                  v-model="sendDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="send_date_formated"
                      label="Data de envio do documento"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="formData.send_date"
                    @input="sendDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                sm7
                optionalFields
                v-show="uploadType != 'attchment' && !financialUploadMode"
              >
                <v-autocomplete
                  :rules="$store.state.formRules.requiredSelect"
                  v-model="formData.condominium_id"
                  :items="condominiums"
                  item-text="name_fantasy"
                  item-value="condominium_id"
                  label="Selecione o condomínio"
                  single-line
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 v-show="uploadType == 'financial'">
                <v-autocomplete
                  :rules="$store.state.formRules.requiredSelect"
                  v-model="formData.financialModelId"
                  :items="financialModels"
                  item-text="financialModel"
                  item-value="financialModelId"
                  label="Selecione o modelo de planilha"
                  single-line
                ></v-autocomplete>
              </v-flex>
              <v-flex xs10 optionalFields v-show="uploadType == 'Docs'">
                <v-autocomplete
                  v-model="formData.type"
                  :rules="$store.state.formRules.requiredSelect"
                  :items="$store.state.documents.docTypesList"
                  item-text="type"
                  item-value="id"
                  label="Selecione o tipo do documento"
                  single-line
                ></v-autocomplete>
              </v-flex>
              <!-- Campos da área financeira -->
              <v-flex xs5 v-if="financialUploadMode">
                <v-menu
                  v-model="refMonthDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      clearable
                      v-model="refMonthDateFormated"
                      label="Mês de referência"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="month"
                    no-title
                    v-model="formData.refMonthDateSel"
                    @input="refMonthDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs7 pl-3 v-if="financialUploadMode">
                <v-autocomplete
                  v-model="formData.financialType"
                  :rules="$store.state.formRules.required"
                  :items="financialDocTypes"
                  item-text="type"
                  item-value="id"
                  label="Tipo do arquivo"
                  single-line
                ></v-autocomplete>
              </v-flex>
              <!-- Campos da área financeira -->
              <v-flex xs2>
                <upLoadEditionDocTypes
                  v-show="uploadType == 'Docs'"
                  class="justify-left pt-3"
                  :docTypes="$store.state.documents.docTypesList"
                  :reloadDocTypes="_ => getDocTypes()"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog">Cancelar</v-btn>
        <v-btn color="primary" flat @click="doSend">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import upLoadEditionDocTypes from '../syndication/documentations/EditionDocTypes'
import * as moment from 'moment'

const defaultForm = {
  refMonthDateSel: '',
  financialType: '',
  condominium_id: '',
  type: '',
  send_date: new Date().toISOString().substr(0, 10),
  fileName: '',
  file: '',
  id: ''
}

export default {
  name: 'UploadFile',

  components: { upLoadEditionDocTypes },

  props: {
    disableFields: { type: Boolean, default: false },
    financialUploadMode: Boolean,
    hideOpenButton: Boolean,
    margin: String,
    uploadType: String,
    openForm: Function,
    closeForm: Function,
    sendFile: Function,
    dialog: Boolean,
    idToEdit: Number
  },

  data () {
    return {
      refMonthDateMenu: false,
      financialDocTypes: [
        { type: 'Orçamento', id: 'budget' },
        { type: 'Realizado', id: 'realized' }
      ],
      formData: { ...defaultForm },
      condominiums: [],
      docTypes: [],
      financialModels: [],
      sendDateMenu: false,
      validForm: true
    }
  },

  computed: {
    refMonthDateFormated: {
      get () {
        return this.formData.refMonthDateSel
          ? moment(this.formData.refMonthDateSel).format('MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          this.formData.refMonthDateSel = moment(value).format('MM/YYYY')
        } else {
          this.formData.refMonthDateSel = ''
        }
      }
    },

    dialogShow () {
      return this.dialog
    },

    send_date_formated () {
      return moment(this.formData.send_date).format('DD/MM/YYYY')
    }
  },

  watch: {
    dialogShow: function (val) {
      if (val) {
        this.resetFile()
        this.condominiums = this.$store.state.condominiums.condominiumList /* this.$parent.$parent.$refs.searchDocs.condominiums; */
        this.docTypes = this.$store.state.documents.docTypesList /* this.$parent.$parent.$refs.docsForm.docTypes; */
        this.formData.id = this.idToEdit ? this.idToEdit : null
      } else {
        this.$refs.uploadForm.resetValidation()
      }
    }
  },

  methods: {
    getDocTypes () {
      this.$store.dispatch('documents/getDocTypes')
    },

    resetFile () {
      [...document.querySelectorAll('.fileToSend')].map(field => {
        field.value = ''
      })
      // document.getElementById("fileToSend").value = "";
      this.formData = { ...defaultForm }
      this.$refs.uploadForm.resetValidation()
      // this.formData.fileName = "";
      // this.formData.fileSend = "";
    },

    onFilePicked (e) {
      const files = e.target.files

      console.log('Size: ', e.target.files[0].size)

      if (files[0] !== undefined) {
        this.formData.fileName = files[0].name
        this.formData.file = files[0]
      } else {
      }
    },

    pickFile () {
      this.$refs.selectedFile.click()
    },

    resetDialog () {
      this.$props.closeForm()
    },

    doSend () {
      if (!this.formData.fileName) {
        this.$refs.iptFile.focus()
        return
      }

      this.$props.sendFile(this.formData)
    }
  }
}
</script>

<style>
</style>
